var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H54C57.3137 0 60 2.68629 60 6V54C60 57.3137 57.3137 60 54 60H6C2.68629 60 0 57.3137 0 54V6Z",
    fill: "#E6E0F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3632 53.1456C21.0624 53.1456 18.5664 50.9184 17.2992 48.2304L21.6768 45.5808C22.5216 47.0784 23.2896 48.3456 25.1328 48.3456C26.8992 48.3456 28.0128 47.6544 28.0128 44.9664V26.688H33.3888V45.0432C33.3888 50.6112 30.1248 53.1456 25.3632 53.1456Z",
    fill: "#10061C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5268 53.1456C40.5348 53.1456 37.3092 50.7648 35.7348 47.6544L40.1124 45.12C41.2644 47.0016 42.762 48.384 45.4116 48.384C47.6388 48.384 49.0596 47.2704 49.0596 45.7344C49.0596 43.8912 47.6004 43.2384 45.1428 42.1632L43.7988 41.5872C39.9204 39.936 37.3476 37.8624 37.3476 33.4848C37.3476 29.4528 40.4196 26.3808 45.2196 26.3808C48.6372 26.3808 51.0948 27.5712 52.8612 30.6816L48.6756 33.3696C47.754 31.7184 46.7556 31.0656 45.2196 31.0656C43.6452 31.0656 42.6468 32.064 42.6468 33.3696C42.6468 34.9824 43.6452 35.6352 45.9492 36.6336L47.2932 37.2096C51.8628 39.168 54.4356 41.1648 54.4356 45.6576C54.4356 50.496 50.634 53.1456 45.5268 53.1456Z",
    fill: "#10061C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJsLogo);
export default __webpack_public_path__ + "static/media/JSLogo.00198f5fee783fcf652256088e52cb70.svg";
export { ForwardRef as ReactComponent };